import { render, staticRenderFns } from "./ReservationStaff.vue?vue&type=template&id=503b9924&scoped=true&"
import script from "./ReservationStaff.vue?vue&type=script&lang=js&"
export * from "./ReservationStaff.vue?vue&type=script&lang=js&"
import style0 from "./ReservationStaff.vue?vue&type=style&index=0&id=503b9924&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503b9924",
  null
  
)

export default component.exports